import {
    fetchBackofficeCompanies,
    fetchCompanyDetailsById,
    editCompany,
    getFinancialList, 
    getCompanyGSCList,
    inactivateEntityCompanyById,
    registerNewCompany,
    uploadCompanyDoc,
    downloadCompanyDocument,
    deleteCompanyDocument,
    getEntityGroupsDropdown,
} from "../../api/backoffice";

import Vue from "vue";
import i18n from "@/i18n";
//import store from "@/store";
//import { bus } from '@/utils/event-bus';
import { downloadFile } from "@/utils/documents";

const hasInvalidValue = (v) => {
    if(v?.type === "dropdown") {
        let invalidValue = true;
        v.options?.map((option) => {
            if(option.selected) {
                invalidValue = option?.value == null || v.value === "-1";
            } 
        });
        return invalidValue;
    } 
    
    return v.value == null || v.value === "";
};


const getDefaultState = () => {
    return {
        // ******* Backoffice company details *************
        companyBkoForm: {},
        companyDetails: {},
        companyDetailsDropdown: {
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: "PT",
                text: i18n.t("global.country.portugal"),
            }, {
                value: "ES",
                text: i18n.t("global.country.spain"),
            }],
            companyGSCList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            financialList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            brands: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 'ALL',
                    text: i18n.t("ALL"),
                }
            ],
            entityGroupList: [],
        },
        containsChanges: false,
        // ******* Backoffice comapanies list *************
        backofficeCompanies: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            country: "",
            status: "S",
            filter_search: "",
        },
        dropdownsFilters: {
            statusList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "Ativo",
                selected: true,
            }, {
                value: 0,
                text: "Inativo",
            }],
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: "PT",
                text: "Portugal",
            }, {
                value: "ES",
                text: "Espanha",
            }],
        },
        isTableLoading: false,
        companyId: -1,
        companyDocuments: [],
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice company details *************
    getCompanyBkoForm: (state) => state.companyBkoForm,
    getCompanyDetails: (state) => state.companyDetails,
    getCompanyGSCList: (state) => state.companyDetailsDropdown.companyGSCList,
    getFinancialList: (state) => state.companyDetailsDropdown.financialList,
    getNationalityList: (state) => state.companyDetailsDropdown.nationalityList,
    getContainsChanges: (state) => state.containsChanges,
    // ******* Backoffice comapnies list *************
    getBackofficeCompanies: (state) => state.backofficeCompanies,
    getCompaniesTotalPages: (state) => state.totalPages,
    getCompaniesTotalResults: (state) => state.totalResults,
    getCompaniesFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getCompaniesFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    isTableLoading: (state) => state.isTableLoading,
    getCompanyId: (state) => state.companyId,
    getCompanyDocumentData: (state) => state.companyDocuments,
    getCarBrands: (state) => state.companyDetailsDropdown.brands,
    getEntityGroupList: (state) => state.companyDetailsDropdown.entityGroupList,
};

const mutations = {
    // ******* Backoffice company details *************
    setCompanyBkoForm(state, companyBkoForm) {
        state.companyBkoForm = companyBkoForm;
    },
    setCompanyDetails(state, companyDetails) {
        state.setCompanyDetails = companyDetails;
    },
    resetCompanyDetailsDropdownsState(state) {
        state.companyDetailsDropdown = getDefaultState().companyDetailsDropdown;
    },
    setEntitySimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return item["NAME"];
        });
        state[stateType][type] = dropdownNeoObj;
    },
    setCompanyGSCSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["id"], text: item["name"] };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setFinancialSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            if(item["STATUS"] == "N") {
                return { value: item["ID"], text: item["NAME"], disabled: true, };
            } else {
                return { value: item["ID"], text: item["NAME"] };
            }
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setFieldValue(state, { key, value, options, onChangeActions }) {
        console.log(options);
        console.log(onChangeActions);
        
        state?.companyBkoForm?.form?.forEach((form) => {
            let field = form.fields.find((f) => f.key === key);
            
            if (field && value && field.type !== "dropdown") {   
                field.value = value;

                field.hasError = false;
            }
            if (field && value && field.type === "dropdown") {   
                field.hasError = false;
            }
        });

    },
    setIncrementField(state, { key }) {
        state?.companyBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setFieldAttribute(state, { key, attribute, value }) {

        state?.companyBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            
            if (field) {
                if(!(field.key?.startsWith("idFinancial") || field.key?.startsWith("idGscCompany"))) {
                    var dropdownNeoObj = value.map((item) => {
                        return { value: item["id"], text: item["name"] };
                    });
            
                    dropdownNeoObj = [
                        {
                            value: -1,
                            text: i18n.t("dropdownSelection"),
                            disabled: true,
                        },
                        ...dropdownNeoObj,
                    ];
                    field[attribute] = dropdownNeoObj;
                } else {
                    field[attribute] = value;
                }

            }
        });
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    },
    // ******* Backoffice companies list *************
    setBackofficeCompanies(state, backofficeCompanies) {
        state.backofficeCompanies = backofficeCompanies;
    },
    setCompaniesTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setCompaniesTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setCompaniesFilters(state, companiesFilters) {
        state.companiesFilters = companiesFilters;
    },
    setMixedDropdownValues(
        state,
        {
            data,
            stateType = "dropdownsFilters",
            type,
            valueKey = "ID",
        }
    ) {
        var dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
    setCompanyId(state, companyId) {
        state.companyId = companyId;
    },
    setCompanyDocumentData(state, companyDocuments) {
        state.companyDocuments = companyDocuments;
    },
    setBrandList(state, {data, stateType, type}) {
        const dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 'ALL',
                text: i18n.t("ALL"),
            }
        ];

        Object.keys(data).forEach((element) => {
            dropdownNeoObj.push({value: element, text: element});
        });

        state[stateType][type] = dropdownNeoObj;
    },
    setEntityGroupSimpleList(state, { data, stateType, type }) {
        state[stateType][type] = data;
    },
    setEntityGroupList(state, entityGroupList) {
        state.companyDetails.entityGroupList = entityGroupList;
    }
};

const actions = {
    // ******* Backoffice comapny details *************
    async getCompanyDetails({ commit }, idCompany) {
        try {
            const response = await fetchCompanyDetailsById(idCompany);

            const data = response?.data?.data;
            
            commit("setCompanyDetails", data?.generalData);
            
            commit("setCompanyId", data?.generalData?.id);
            commit("setCompanyDocumentData", data?.documentData);
            return data?.generalData;
        } catch (error) {
            console.log(error)
        }
    },
    async checkIfFormIsValid({ commit }) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.companyBkoForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", { field: i18n.t(label) })}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async registerNewCompany({ commit }, payload) {
        commit("setTableLoading", false);
        try {
            const response = await registerNewCompany(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    // ******* Backoffice companies list *************
    async getBackofficeCompanies({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeCompanies(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeCompanies", response?.data?.data);
            commit("setCompaniesTotalPages", response?.data?.pages);
            commit("setCompaniesTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async getCompanyGSCList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const country = idInstance == 1 ? 'PT' : 'ES';
            
            const response = await getCompanyGSCList(idInstance, country);
            const companiesGSC = response?.data?.data;
            commit("setCompanyGSCSimpleList", {
                data: companiesGSC,
                stateType: "companyDetailsDropdown",
                type: "companyGSCList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getFinancialList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getFinancialList(idInstance);
            const financialList = response?.data?.data;
            commit("setFinancialSimpleList", {
                data: financialList,
                stateType: "companyDetailsDropdown",
                type: "financialList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async inactivateCompany({ commit }, companyId) {
        commit("setTableLoading", false);
        try {
            const response = await inactivateEntityCompanyById(companyId);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async editCompany({ commit }, { companyId, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await editCompany(companyId, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async uploadCompanyDoc({ commit }, { companyId, base64File, filename, brand }) {
        commit("setTableLoading", false);
        try {
            const response = await uploadCompanyDoc({ companyId, base64File, filename, brand });
            return response;
        } catch (error) {
            Vue.$toast.open({
                message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.submitError"),
                dismissible: true,
                type: "error",
            });
        }
    },
    async downloadCompanyDocument({ commit }, requestData) {
        commit("setTableLoading", false);
        
        try {
            const response = await downloadCompanyDocument(requestData);
            downloadFile(response.data, requestData?.documentName);
        } catch (error) {
            Vue.$toast.open({
                message: i18n.t("form.error.downloadError"),
                dismissible: true,
                type: "error",
            });
        }
    },
    async deleteCompanyDocument({ commit }, requestData) {
        commit("setTableLoading", false);
        
        try {
            const response = await deleteCompanyDocument(requestData);
            return response;
        } catch (error) {
            console.log(error);
        }
    },
    async getBrands({commit}, eurotaxBrandData) {
        const vehicleCategory = 'Ligeiro de Passageiros';
        const eurotax = eurotaxBrandData[vehicleCategory];

        commit("setBrandList", {
            data: eurotax,
            stateType: "companyDetailsDropdown",
            type: "brands",
        });
    },
    async getEntityGroupList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityGroupsDropdown(idInstance);
            const entityGroups = response?.data?.data;

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "companyDetailsDropdown",
                type: "entityGroupList",
            });
        } catch (error) {
            console.log(error)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
